import { RoutingActions } from '@state/slices/app';
import { handlePathChange } from './commonSearchSlice';
import { createListener } from '@state/store/createListener';

// Setup function to initialize all common search listeners
export const setupCommonSearchListeners = () => {
  // Start listening for routing path initialization
  createListener([RoutingActions.INITIALIZE_PATH], async (_action, listenerApi) => {
    // Dispatch the async thunk to handle path change
    listenerApi.dispatch(handlePathChange());
  });
};
